import { NextI18nService } from '../../services';

export const appEnhancer = NextI18nService.appEnhancer;
